import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["crmObject", "nonCrmObject"];
import { useTracker } from 'asset-actions-lib/context/TrackerContext';
import { useCallback } from 'react';
export function useTrackAssetActionInteraction() {
  const {
    applicationId,
    tracker,
    onTrackEvent,
    objectTypeId,
    objectId
  } = useTracker();
  return useCallback(eventProps => {
    if (onTrackEvent) {
      onTrackEvent(eventProps.action, eventProps);
    }

    /**
     * No need to track events that don't belong to asset-actions-lib
     */
    if (!tracker || eventProps.action !== 'click-action' && eventProps.action !== 'open-dropdown') {
      return;
    }
    const rest = _objectWithoutPropertiesLoose(eventProps, _excluded);
    tracker.track('actionsLibInteraction', Object.assign({
      applicationId,
      objectType: objectTypeId,
      objectId
    }, rest));
  }, [applicationId, objectTypeId, objectId, onTrackEvent, tracker]);
}